module.exports = __webpack_public_path__ + "media/images/bg-login-a3eaa0623842de6d85d79373bc4aa1d7.jpg";